import { formatInTimeZone } from 'date-fns-tz';
import type { Counterparty, CounterpartyTeamMember } from '../types';

const MSK = 'Europe/Moscow';

/** Допуск |баланса| (USDT) при удалении команды / исключении участника. */
export const TEAM_BALANCE_DELETE_TOLERANCE_USDT = 1;

export function salaryBalanceBlocksTeamDeletion(balance: number): boolean {
  return Math.abs(balance) > TEAM_BALANCE_DELETE_TOLERANCE_USDT;
}

export function aggregateTeamBalances(members: CounterpartyTeamMember[] | undefined): {
  available: number;
  held: number;
  total: number;
  nextReleaseAt: string | null;
} {
  let available = 0;
  let held = 0;
  let nextReleaseAt: string | null = null;
  let nextMs = Infinity;

  for (const m of members ?? []) {
    const a = m.salary_balance_available;
    const h = m.salary_balance_held;
    const hasSplit = a != null || h != null;
    const av = hasSplit ? (a ?? 0) : (m.salary_balance ?? 0);
    const hd = hasSplit ? (h ?? 0) : 0;
    available += av;
    held += hd;

    const t = m.next_salary_hold_release_at;
    if (t && hd > 0) {
      const ms = Date.parse(t);
      if (!Number.isNaN(ms) && ms < nextMs) {
        nextMs = ms;
        nextReleaseAt = t;
      }
    }
  }

  const sumTotal = available + held;
  return { available, held, total: sumTotal, nextReleaseAt };
}

/** Личные суммы контрагента с учётом строки участника в команде (если есть). */
export function pickCounterpartyBalanceSlice(
  user: Counterparty,
  member: CounterpartyTeamMember | undefined
): { available: number; held: number; total: number; nextReleaseAt: string | null } {
  const hasSplit =
    user.salary_balance_available != null ||
    user.salary_balance_held != null ||
    member?.salary_balance_available != null ||
    member?.salary_balance_held != null;

  let available: number;
  let held: number;
  if (hasSplit) {
    available = member?.salary_balance_available ?? user.salary_balance_available ?? 0;
    held = member?.salary_balance_held ?? user.salary_balance_held ?? 0;
  } else {
    available = member?.salary_balance ?? user.salary_balance ?? 0;
    held = 0;
  }

  const total =
    member?.salary_balance ??
    user.salary_balance ??
    available + held;

  const nextReleaseAt =
    member?.next_salary_hold_release_at ?? user.next_salary_hold_release_at ?? null;

  return { available, held, total, nextReleaseAt };
}

export function formatNextSalaryHoldLine(iso: string | null, held: number): string | null {
  if (held <= 0) return null;
  if (!iso) return 'Ближайший разхолд: уточняется';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  // API отдаёт момент (RFC3339); показываем всегда в МСК — так же, как операционное время в заявках.
  const when = formatInTimeZone(d, MSK, 'dd.MM.yyyy, HH:mm');
  return `Ближайший разхолд: ${when} МСК`;
}
